import { t } from "../../i18n";
import { File, Folder } from "lucide-react";
import { CopyButton } from "../CopyButton";
import { GenericResult } from "./GenericResult";
import { Card } from "./WorkspaceResultCard";
import { Heading } from "./WorkspaceResultHeading";

export function FileList({
  paths,
  title,
  icon,
}: {
  paths: string[];
  title: string;
  icon: React.ReactNode;
}) {
  if (!paths.length)
    return <GenericResult value={{ message: t("No matching paths found") }} />;
  return (
    <Card tone="stone">
      <Heading icon={icon}>{title}</Heading>
      <div className="mt-3 divide-y divide-stone-200 overflow-hidden rounded-xl border border-stone-200 dark:divide-white/10 dark:border-white/10">
        {paths.slice(0, 100).map((path, index) => {
          const folder =
            path.endsWith("/") || !path.split("/").at(-1)?.includes(".");
          return (
            <div
              key={`${path}-${index}`}
              className="flex min-w-0 items-center gap-2 px-3 py-2 text-xs"
            >
              {folder ? (
                <Folder size={14} className="shrink-0 text-amber-600" />
              ) : (
                <File size={14} className="shrink-0 text-stone-400" />
              )}
              <code className="min-w-0 flex-1 truncate text-stone-700 dark:text-stone-200">
                {path}
              </code>
              <CopyButton value={path} label={t("Copy path")} />
            </div>
          );
        })}
      </div>
      {paths.length > 100 && (
        <p className="mt-2 text-xs text-stone-500">
          {t("Showing the first {{count}} paths", { count: 100 })}
        </p>
      )}
    </Card>
  );
}
